import type { CityConfig } from "../city-template/types";

export const keokukConfig: CityConfig = {
  city: "Keokuk",
  state: "Iowa",
  stateAbbr: "IA",
  slug: "keokuk",
  route: "/cities/keokuk",
  title: "Emergency Passport Keokuk, IA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Keokuk, IA — as fast as 24 hours. Serving Southeast Iowa and Tri-State border region. A+ BBB rated registered State Dept. courier serving Roquette America and Henniges Automotive professionals, Mississippi River commerce workers, and Lee County travelers. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Keokuk, IA",
  heroSubtitle: "Roquette America business trip to France with a week's notice and your passport expired? Henniges Automotive conference in Germany and no passport to show? Mississippi River barge crew heading to international waters with tight deadlines? We help Keokuk and Southeast Iowa residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Keokuk%20Iowa%20Mississippi%20River%20waterfront%20with%20historic%20Lock%20and%20Dam%2019%20industrial%20riverfront%20Victorian%20architecture%20and%20bluff%20views%20Southeast%20Iowa%20tri%20state%20border%20region%20at%20golden%20hour%20warm%20sunlight%20on%20the%20river&width=1800&height=700&seq=keokuk-hero-ia-2026&orientation=landscape",
  heroImageAlt: "Keokuk Iowa Mississippi River waterfront and Lock and Dam 19 Southeast Iowa tri-state region at golden hour",
  geoPosition: "40.3973;-91.3849",
  geoPlacename: "Keokuk, Iowa",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B Wells Dr, 9th Floor, Chicago, IL 60604",
    distance: "Located in the Chicago Loop — approximately 270 miles northeast of Keokuk via US-218 and I-80",
  },
  nearbyCitiesZips: [
    { name: "Keokuk", zips: "52632" },
    { name: "Fort Madison", zips: "52627" },
    { name: "Burlington", zips: "52601" },
    { name: "Mount Pleasant", zips: "52641" },
    { name: "Fairfield", zips: "52556" },
    { name: "Ottumwa", zips: "52501" },
    { name: "Donnellson", zips: "52625" },
    { name: "West Point", zips: "52656" },
    { name: "Denmark", zips: "52624" },
    { name: "Montrose", zips: "52639" },
    { name: "Quincy, IL", zips: "62301" },
    { name: "Hannibal, MO", zips: "63401" },
    { name: "Canton, MO", zips: "63435" },
    { name: "Warsaw, IL", zips: "62379" },
    { name: "Nauvoo, IL", zips: "62354" },
    { name: "Iowa City", zips: "52240–52246" },
    { name: "Cedar Rapids", zips: "52401–52411" },
    { name: "Davenport", zips: "52801–52807" },
    { name: "Des Moines", zips: "50301–50327" },
    { name: "Macomb, IL", zips: "61455" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Southeast Iowa departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Tri-State Coverage", desc: "Serving Lee County and Iowa-Illinois-Missouri border region" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Burlington, IA", route: "/cities/burlington-ia" },
    { name: "Fast passport renewal in Fort Madison, IA", route: "/fort-madison" },
    { name: "Emergency passport help in Des Moines, IA", route: "/cities/des-moines" },
    { name: "Urgent passport services in Iowa City, IA", route: "/cities/iowa-city" },
    { name: "Same-day passport help in Davenport, IA", route: "/cities/davenport" },
    { name: "Passport courier services in Cedar Rapids, IA", route: "/cities/cedar-rapids" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Keokuk remotely via secure courier. We do not have a walk-in office in Keokuk — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Lee County and the entire Southeast Iowa tri-state region.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Lee County and the Southeast Iowa tri-state region including Fort Madison, Burlington, and the Illinois-Missouri border communities",
  serviceAreaIntro: "From the historic Lock and Dam 19 on the Mississippi River to Roquette America's corn wet milling facility employing hundreds, from Henniges Automotive manufacturing with its global supply chain connections to the Victorian-era Grand Theater on Main Street, from the Keokuk-Hamilton Bridge connecting Iowa to Illinois to the Port of Keokuk servicing river commerce, from the bluff-top neighborhoods overlooking the Mississippi to the farm communities of rural Lee County — Fast Passport Center serves the entire Keokuk region. We regularly help travelers from Keokuk, Fort Madison, and Burlington get their passports fast without the 4-hour drive to Chicago.",
  nearbyCitiesIntro: "We serve all Keokuk neighborhoods and the surrounding Southeast Iowa tri-state area including Fort Madison, Burlington, Mount Pleasant, Montrose, and West Point. If you are anywhere in Lee County, Des Moines County, or the tri-state border region, we have you covered.",
  howItWorksIntro: "Most Keokuk travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Southeast Iowa travelers often face a 4-plus-hour drive to the nearest regional passport agency in Chicago. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Keokuk and Lee County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Keokuk? Here are the most common ones we hear from Southeast Iowa travelers.",
  statePageRoute: "/states/iowa",
  statePageName: "Iowa",
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (IA HHS)", url: "https://hhs.iowa.gov/programs/programs-and-services/vital-records", desc: "Iowa Department of Health and Human Services — Bureau of Vital Records for birth and death certificates statewide" },
    { label: "Marriage Licenses (Lee County Recorder)", url: "https://www.leecounty.org/recorder", desc: "Lee County Recorder — marriage license applications and certified copies for Keokuk and Lee County" },
    { label: "Divorce Decrees (Lee County Clerk of Court)", url: "https://www.iowacourts.gov/courts/district-court/district-8b/lee/", desc: "Lee County Clerk of Court — divorce decree records for Keokuk and Lee County residents" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Iowa birth, death, marriage, and divorce certificates online via VitalChek — fastest state-approved method" },
  ],
  dmvWebsite: "https://iowadot.gov/mvd",
  dmvLabel: "Iowa DOT — Motor Vehicle Division",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Keokuk travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Andre L.",
      location: "Keokuk, IA",
      rating: 5,
      text: "Roquette sent me to the parent company in Lestrem, France with 7 days notice. My passport was expired. Fast Passport Center had it in 3 days. Mon directeur was impressed. Now Roquette HR recommends them to all traveling employees.",
      service: "Passport Renewal",
    },
    {
      name: "Captain Ron H.",
      location: "Montrose, IA",
      rating: 5,
      text: "Mississippi River tug crew heading into Canadian waters — needed my passport renewed fast. Fast Passport Center got it in 2 days. I was back on the river before the tow left. River guys don't talk about much, but they talk about Fast Passport Center.",
      service: "Emergency Passport",
    },
    {
      name: "Maria and Jose G.",
      location: "Fort Madison, IA",
      rating: 5,
      text: "Family wedding in Mexico — we realized our kids' passports were expired 5 days before. Fast Passport Center got all four done in 4 days. We made it for the whole celebration. The bride was so relieved!",
      service: "Child Passport",
    },

  ],
  facilities: [
    {
      id: "keokuk-1",
      name: "Keokuk Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "305 Blondeau St",
      city: "Keokuk",
      state: "IA",
      zip: "52632",
      phone: "(319) 524-2341",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Keokuk",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Keokuk facility. Serves Lee County. Appointments strongly recommended. Call ahead for passport hours.",
      icon: "ri-mail-line",
    },
    {
      id: "keokuk-2",
      name: "Lee County Recorder's Office",
      type: "County Recorder Passport Acceptance",
      address: "933 Ave H",
      city: "Fort Madison",
      state: "IA",
      zip: "52627",
      phone: "(319) 372-1133",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "20 miles north in Fort Madison",
      website: "https://www.leecounty.org/recorder",
      websiteLabel: "Lee County Recorder",
      notes: "Accepts passport applications. Good alternative with extended county office hours.",
      icon: "ri-government-line",
    },
    {
      id: "keokuk-3",
      name: "Fort Madison Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "515 Ave G",
      city: "Fort Madison",
      state: "IA",
      zip: "52627",
      phone: "(319) 372-1531",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles north of Keokuk",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Fort Madison and northern Lee County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "keokuk-4",
      name: "Burlington Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "300 N Main St",
      city: "Burlington",
      state: "IA",
      zip: "52601",
      phone: "(319) 752-4887",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "40 miles north of Keokuk",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Des Moines County and Burlington metro. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "keokuk-5",
      name: "Mount Pleasant Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 S Jefferson St",
      city: "Mount Pleasant",
      state: "IA",
      zip: "52641",
      phone: "(319) 385-2811",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "35 miles northwest of Keokuk",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Henry County and Iowa Wesleyan University community. Full passport services.",
      icon: "ri-mail-line",
    },
    {
      id: "keokuk-6",
      name: "Quincy Main Post Office — IL",
      type: "USPS Passport Acceptance Facility",
      address: "3535 Locust St",
      city: "Quincy",
      state: "IL",
      zip: "62301",
      phone: "(217) 222-2481",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "35 miles southeast in Quincy, IL",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Larger Illinois facility across the river. Full passport services with extended hours.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4+ hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Courier Service", agency: "Not available — self-transport only", fpc: "Registered courier hand-delivers documents" },
    { feature: "Photo Services", agency: "Not available at agency — must bring own", fpc: "Photo review and guidance included" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Small-town photo shops in Southeast Iowa often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Lee County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Keokuk applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Southeast Iowa families at the county clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Keokuk travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Keokuk." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Keokuk address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Keokuk before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Keokuk for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 4-plus-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Keokuk?", a: "Fast Passport Center offers fast passport renewal in Keokuk in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Keokuk?", a: "The nearest regional passport agency to Keokuk is the Chicago Passport Agency, approximately 270 miles northeast via US-218 and I-80. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Keokuk without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Keokuk?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 4-plus hours from Keokuk — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Lee County and Southeast Iowa residents." },
    { q: "Do you serve the tri-state border region?", a: "Absolutely. Fast Passport Center serves the entire tri-state border region including Keokuk, Fort Madison, Burlington, and communities across the river in Illinois and Missouri. Our courier service works seamlessly from any address in Lee County and the tri-state area." },
    { q: "Can I expedite a child passport in Keokuk?", a: "Yes. Fast Passport Center expedites child passports in Keokuk for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Southeast Iowa families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Keokuk with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart — Keokuk", address: "300 N Park Dr, Keokuk, IA 52632", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Fort Madison", address: "4823 Ave O, Fort Madison, IA 52627", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Burlington", address: "324 W Agency Rd, West Burlington, IA 52655", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Quincy, IL", address: "2400 Broadway St, Quincy, IL 62301", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Quincy, IL", address: "5211 Broadway St, Quincy, IL 62305", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Quincy, IL", address: "3201 Broadway St, Quincy, IL 62301", hours: "Mon–Sun: 8AM–10PM" },
  ],
  dmvLocations: [
    {
      name: "Iowa DOT — Fort Madison Driver's License",
      address: "2208 Ave L, Fort Madison, IA 52627",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services for Lee County. Appointment recommended.",
      featured: true,
    },
    {
      name: "Iowa DOT — Burlington Driver's License",
      address: "2850 Mt Pleasant St, Burlington, IA 52601",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Des Moines County. REAL ID available.",
      featured: false,
    },
    {
      name: "Iowa DOT — Mount Pleasant Driver's License",
      address: "1200 E Washington St, Mount Pleasant, IA 52641",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Henry County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "BRL",
      name: "Southeast Iowa Regional Airport",
      distance: "40 miles north of Keokuk",
      address: "2515 Summer St, Burlington, IA 52601",
      note: "Regional airport with daily flights to Chicago and St. Louis. About 45 minutes from Keokuk.",
      flightUrl: "https://www.burlingtoniowaairport.com/",
      flightLabel: "BRL Airport",
      featured: true,
    },
    {
      code: "MLI",
      name: "Quad Cities International Airport",
      distance: "100 miles north of Keokuk",
      address: "2200 69th Ave, Moline, IL 61265",
      note: "Major regional airport with national connections. About 1 hour 45 minutes from Keokuk.",
      flightUrl: "https://www.qcairport.com/",
      flightLabel: "MLI Airport",
      featured: false,
    },
    {
      code: "UIN",
      name: "Quincy Regional Airport",
      distance: "35 miles southeast of Keokuk",
      address: "1647 Highway 104, Quincy, IL 62305",
      note: "Regional airport with Cape Air service to Chicago and St. Louis. About 45 minutes from Keokuk.",
      flightUrl: "https://www.quincyil.gov/",
      flightLabel: "UIN Airport",
      featured: false,
    },
  ],
};